import { render, staticRenderFns } from "./BaseCustodyPanel.vue?vue&type=template&id=4124b3b6"
import script from "./BaseCustodyPanel.vue?vue&type=script&lang=js"
export * from "./BaseCustodyPanel.vue?vue&type=script&lang=js"
import style0 from "./BaseCustodyPanel.vue?vue&type=style&index=0&id=4124b3b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports